import * as Yup from 'yup';
import { RequiredStringSchema } from 'yup/lib/string';

const COMMON_TYPOS = [
    '.con',
    'gmial.com',
    'gamil.com',
    'gmai.com',
    'gmal.com',
    'gnail.com',
    'gmail.con',
    'gmail.cmo',
    'gmaiil.com',
    'gamil.co',
    'gmaill.com',
    'hotamil.com',
    'htomail.com',
    'hotmal.com',
    'hotmai.com',
    'hotmaiil.com',
    'hotmail.con',
    'hotmai.co',
    'hormail.com',
    'hotmial.com',
    'hottmail.com',
    'yaho.com',
    'yhaoo.com',
    'yahho.com',
    'yajoo.com',
    'yaho.co',
    'yahoocom',
    'yhaoo.co',
    'yahooo.com',
    'yaho.cmo',
    'yahu.com',
    'outlok.com',
    'otulook.com',
    'outloo.com',
    'outlok.com',
    'outllok.com',
    'outlook.cmo',
    'oulook.com',
    'outloook.com',
    'outlk.com',
    'oulook.co',
];

export const CORPORATE_EMAIL_DOMAINS = [
    'umpquabank.com',
    'brightsidewindows.com',
    'adidas.com',
    'alaskaair.com',
    'beavertontoyota.com',
    'capitolauto.com',
    'cgmtd.com',
    'lillardtoyota.com',
    'dickhannah.com',
    'swickard.com',
    'lumsautocenter.com',
    'tonkin.com',
    'royalmoore.com',
    'toyotaofgladstone.com',
    'toyotaofportland.com',
    'vancouvertoyota.com',
    'wilsonvilletoyota.com',
    'mcgeeservices.com',
    'horizonair.com',
];

export const emailValidationSchema = (
    initialEmailValue: undefined | string = undefined,
    studentRushFlag = false,
): RequiredStringSchema<string | undefined, Record<string, unknown>> => {
    const isStudentRush = sessionStorage.getItem('source') === 'studentrush' || studentRushFlag;

    return Yup.string()
        .email('Invalid email address')
        .test(
            'len',
            isStudentRush ? 'Please enter valid .edu email address' : 'Please check your email address again',
            (val) => {
                if (initialEmailValue) {
                    return true;
                }
                if (!val) {
                    return false;
                }

                if (isStudentRush && !val.endsWith('.edu')) {
                    return false;
                }

                // Check for common typos in email address
                if (COMMON_TYPOS.some((typo) => val.endsWith(typo))) {
                    return false;
                }

                return true;
            },
        )
        .required('Required');
};
